import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import {Observable, Subscription, switchMap, tap} from 'rxjs';
import { AUTH_ACCESS_TOKEN_KEY, AUTH_REFRESH_TOKEN_KEY, StorageService } from '../services/storage.service';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {AuthenticationResp, Token} from "../model/staff";

@Injectable({
  providedIn: "root"
})
export class TokenRefreshInterceptor implements HttpInterceptor {
  private isAlreadyRoute = false
  private tokenRefreshInProgress = false;
  refreshTokenExpMinutes = environment.refreshTokenExpMinutes
  subRefreshToken?: Subscription

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private storageService: StorageService,
    private authService: AuthService
  ) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/signIn') || req.url.includes('/refreshToken')) {
      return next.handle(req)
    }

    const user = this.storageService.getUser();
    const refreshTokenStr = this.cookieService.get(AUTH_REFRESH_TOKEN_KEY);
    const accessTokenStr = this.cookieService.get(AUTH_ACCESS_TOKEN_KEY);
    const isLoggedIn = user != null && accessTokenStr.length > 0;
    const isApiUrl = req.url.startsWith(environment.baseUrl);
    if (this.isTokenStringExists(refreshTokenStr)) {
      if (isLoggedIn && isApiUrl) {
        const accessToken: Token = JSON.parse(accessTokenStr);
        if (this.shouldRefreshToken(accessToken) && !this.tokenRefreshInProgress) {
          return this.fetchRefreshToken().pipe(
            switchMap(data => next.handle(req))
          )
        }
        return next.handle(req)
      } else {
        return next.handle(req).pipe(
          tap(event => {
            if (this.tokenRefreshInProgress) return
            this.refreshToken()
          })
        )
      }
    } else {
      this.logOut()
      return next.handle(req)
    }
  }

  private isTokenStringExists(tokenStr: string): boolean {
    return tokenStr.length > 0;
  }

  private refreshToken() {
    this.subRefreshToken?.unsubscribe()
    this.tokenRefreshInProgress = true
    this.subRefreshToken = this.authService.refreshToken().subscribe(
      authenticationResp => {
        this.tokenRefreshInProgress = false
      }
    )
  }

  private fetchRefreshToken(): Observable<AuthenticationResp | null> {
    return this.authService.refreshToken()
  }

  private shouldRefreshToken(accessToken: Token): boolean {
    return (accessToken.expiresAt - new Date().getTime() <= (this.refreshTokenExpMinutes)*60*1000);
  }

  private logOut(): void {
    this.authService.logOut()
    this.router.navigate(['/login']).then(() => {
      // window.location.reload();
    })
  }
}

export const httpTokenRefreshInterceptorProvider = [
  { provide: HTTP_INTERCEPTORS, useClass: TokenRefreshInterceptor, multi: true }
];
